import { Outlet, Navigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { AdminNav } from './AdminNav'
import { useAdmin } from '@/hooks/useAdmin'
import { useAuth } from '@/lib/auth/context'

export function AdminLayout() {
  const { loading: authLoading } = useAuth()
  const { isAdmin, loading: adminLoading } = useAdmin()

  // Show loading while checking
  if (authLoading || adminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          className="w-8 h-8 border-3 border-violet-500 border-t-transparent rounded-full"
        />
      </div>
    )
  }

  // Redirect non-admin users
  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <AdminNav />
      {/* Desktop: offset for collapsed sidebar. Mobile: offset for top bar + safe area */}
      <div className="lg:pl-14 pt-[calc(var(--native-safe-area-inset-top,env(safe-area-inset-top,0px))+48px)] lg:pt-0">
        <Outlet />
      </div>
    </div>
  )
}
